// extracted by mini-css-extract-plugin
export default {"qr_code":"index_qr_code_TMbAm","current_code":"index_current_code_5nUzg","bottom_code":"index_bottom_code_gLvmz"};